var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.646 3.30469C8.50056 3.30469 5.94427 5.86097 5.94427 9.00644V11.7528C5.94427 12.3325 5.69719 13.2162 5.4026 13.7104L4.30976 15.5255C3.63506 16.6468 4.1007 17.8917 5.33608 18.3098C9.43184 19.6782 13.8507 19.6782 17.9465 18.3098C19.0963 17.9297 19.6 16.5708 18.9728 15.5255L17.8799 13.7104C17.5949 13.2162 17.3478 12.3325 17.3478 11.7528V9.00644C17.3478 5.87048 14.782 3.30469 11.646 3.30469Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.404 3.58018C13.1094 3.49466 12.8053 3.42813 12.4917 3.39012C11.5795 3.27609 10.7052 3.34261 9.88794 3.58018C10.1635 2.87696 10.8477 2.38281 11.646 2.38281C12.4442 2.38281 13.1284 2.87696 13.404 3.58018Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4969 18.6523C14.4969 20.2203 13.214 21.5032 11.646 21.5032C10.8668 21.5032 10.1446 21.1801 9.63142 20.667C9.11826 20.1538 8.79517 19.4316 8.79517 18.6523",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e124de510038df7aca480fa70f383680.svg";
export { ForwardRef as ReactComponent };